/* Shared Tailwind (Play CDN) config — load right after the CDN script on every page */
tailwind.config = {
  theme: {
    extend: {
      colors: {
        ink: '#0C0A09', ink2: '#15110E', ink3: '#1F1813',
        bone: '#F2ECE1', bonedim: '#A89E8E',
        skin: '#D8D3C7', skindeep: '#A6A095',
        silver: '#C9C6BD', silverhover: '#E6E2D8',
      },
      fontFamily: {
        display: ['Fraunces', 'serif'],
        anton: ['Anton', 'sans-serif'],
        serif: ['Fraunces', 'serif'],
        sans: ['Inter', 'sans-serif'],
      },
    },
  },
};
